const HttpResponseCodes = {
    HTTP_OK: 200,
    HTTP_INTERNAL_SERVER_ERROR: 500,
    HTTP_BAD_REQUEST: 400,
    HTTP_UNAUTHORISED: 401,
    HTTP_FORBIDDEN: 403,
    HTTP_NOT_FOUND: 404,
    HTTP_TOO_MANY_REQUESTS: 429,
};
export default HttpResponseCodes;
